module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/categories/testicle-3824c608682ed29cd120e62902f9d2df.png";